import type {
  Search,
  SearchFactory,
  SearchParameters,
  SearchParameterValues,
} from 'src/domain';
import { changesBetween } from '../searchParameters/changesBetween';

/**
 * A search transition as the legacy app makes one: from the last completed
 * search, to the parameters Redux holds now, plus this call's own changes.
 *
 * Restoring the completed search settles it, which can clear a value it states
 * but cannot carry. Handing the transition every value `current` states puts
 * those back as changes, so a value the next search can carry survives the
 * trip exactly as it did before the aggregate — a license stated on a creative
 * image search still reaches the film search a link points at, and still
 * outranks a license remembered for film. The next search then clears only
 * what it cannot carry itself.
 *
 * A link builder has one baseline and passes the page being left as both
 * `completed` and `current`; `useSearch` passes the two Redux holds.
 */
export const legacyTransition = (
  factory: SearchFactory,
  completed: SearchParameters,
  current: SearchParameters,
  changes: Partial<SearchParameterValues> = {}
): Search =>
  factory
    .restore(completed)
    .with({ ...changesBetween(completed, current), ...changes });
